<template>
  <div class="container g-flex g-row-center">
    <div class="total-width g-m-t-15">
      <div class="data-item g-m-t-15" v-for="(item,index) in list" :key="index" @click="goDetail(item.id)">
        <div class="g-p-20">
          <div class="g-flex g-row-between">
            <p class="g-weight-font g-font-18 main-text">{{item.title}}</p>
            <p class="remark-text g-font-14">{{item.releaseTime}}</p>
          </div>
          <!-- <div class="g-m-t-15 remark-text g-font-14">
			  {{item.content}}
          </div> -->
        </div>
      </div>
      <!--  分页  -->
      <div class="g-flex g-row-center g-m-t-30" style="position: absolute;bottom: 0;left: 0;right: 0;">
		<el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
			:current-page="params.current" :page-sizes="[10, 20, 30, 40]" :page-size="params.size"
			layout="total, sizes, prev, pager, next, jumper" :total="total">
		</el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
	import {noticeList} from "@/api/api.js"
export default {
  name: "notice-list",
  data(){
    return{
		params:{
			current: 1,
			size: 10,
		},
      list:[],
	  total:0
    }
  },
  mounted() {
  	this.getNoticeList();
  },
  methods:{
	  getNoticeList() {
	  	noticeList(
	  		this.params
	  	).then(res => {
	  		this.list=res.records
	  		this.total=res.total
	  	})
	  },
    // 页数切换
    handleSizeChange(val) {
    	console.log(`每页 ${val} 条`);
    	this.params.size=val;
    	this.getNoticeList()
    },
    // 当前页切换
    handleCurrentChange(val) {
    	console.log(`当前页: ${val}`);
    	this.params.current=val;
    	this.getNoticeList()
    },
  //  跳转详情
    goDetail(id){
      this.$router.push({
        name:'notice-detail',
        query:{
          id:id
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
  .data-item{
    border-radius: 10px;
    background-color: #fff;
  }
</style>
<style scoped>
	.total-width {
		min-height: calc(100vh - 400px);
		position: relative;
	}
</style>